import React, { useEffect, useState } from "react";
import "./app.css";

import Loader from "./components/loader";
import Header from "./components/header";
import Home from "./components/home";
import About from "./components/about";
import Services from "./components/services";
import Testimonials from "./components/testimonials";
import Contact from "./components/contact";
import Footer from "./components/footer";
import WhyChoose from "./components/whychoose";
import Cta from "./components/cta";


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <>
      <Header />
      <Home />
      <About />
      <Services />
      <Testimonials />
      <WhyChoose />
      <Cta />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
